import { render, staticRenderFns } from "./AutomationConfig.vue?vue&type=template&id=d8c7dd2c"
import script from "./AutomationConfig.vue?vue&type=script&lang=js"
export * from "./AutomationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports